import { render, staticRenderFns } from "./GrupoAcessoUsuariosTable.vue?vue&type=template&id=c1227ba8&scoped=true&"
import script from "./GrupoAcessoUsuariosTable.vue?vue&type=script&lang=js&"
export * from "./GrupoAcessoUsuariosTable.vue?vue&type=script&lang=js&"
import style0 from "./GrupoAcessoUsuariosTable.vue?vue&type=style&index=0&id=c1227ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1227ba8",
  null
  
)

export default component.exports